import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IAccountMappingSubFLI, IAccountMappingTemplateGroupItemFLI } from '@modeso/types__aumico-lib-annualreport-be';
import { ISwitchAccountsData } from '../../../interfaces/switch-accounts-data.interface';

@Component({
    selector: 'switch-accounts-form-dialog',
    templateUrl: './switch-accounts-form.dialog.html',
    styleUrls: ['./switch-accounts-form.dialog.scss'],
})
export class SwitchAccountsDialogComponent {
    parentItemSelectionFormControl = new FormControl(undefined, Validators.required);

    constructor(
        private readonly dialogRef: MatDialogRef<
            SwitchAccountsDialogComponent,
            IAccountMappingTemplateGroupItemFLI | IAccountMappingSubFLI | undefined
        >,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) public data: ISwitchAccountsData,
    ) {
        this.addSvgIcon('interface-delete 1');
    }

    closeDialog(): void {
        this.dialogRef.close(undefined);
    }

    save(): void {
        this.dialogRef.close(this.parentItemSelectionFormControl.value);
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }

    public compareSelections(
        object1: IAccountMappingTemplateGroupItemFLI | IAccountMappingSubFLI,
        object2: IAccountMappingTemplateGroupItemFLI | IAccountMappingSubFLI,
    ): boolean {
        return object1.name === object2.name;
    }
}
